export default __webpack_public_path__ + "static/media/action-icon.c0cc3a61.svg";